"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortingOptions = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.sortingOptions = [
    { firstName: 'First Name' },
    { lastName: 'Last Name' },
    { companyName: 'Company' },
];
